import React, { Fragment, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Loader from '../shims/commonUiLayout';
import Wrapper from './Wrapper';
import LayoutRoutes from './LayoutRoutes';

export default function Routers() {
  const basename = process.env.PUBLIC_URL || '/';

  return (
    <Fragment>
      <BrowserRouter basename={basename}>
        <Wrapper>
          <Suspense fallback={<Loader />}>
            <LayoutRoutes />
          </Suspense>
        </Wrapper>
      </BrowserRouter>
    </Fragment>
  );
}
